import { BETTINGWEBSITEGQLSCHEMA } from "./BettingWebsite";
import { MULTILANGUAGEGQLSCHEMA } from "./MultiLanguage";

export const ARTICLERICHTEXTGQLSCHEMA = `
id
Title{
    ${MULTILANGUAGEGQLSCHEMA}
}
Content{
    ${MULTILANGUAGEGQLSCHEMA}
}
`;

export const TOP10ARTICLEMAININFOGQLSCHEMA = `
Title{
    ${MULTILANGUAGEGQLSCHEMA}
}
Description{
    ${MULTILANGUAGEGQLSCHEMA}
}
Keywords{
    ${MULTILANGUAGEGQLSCHEMA}
}
Image
`;

export const TOP10ARTICLEITEMGQLSCEHMA = `
Type
RichText{
    ${ARTICLERICHTEXTGQLSCHEMA}
}
`;

export const TOP10ARTICLEGQLSCHEMA = `
id
MainInfo{
    ${TOP10ARTICLEMAININFOGQLSCHEMA}
}
Top10BettingWebsites{
    ${BETTINGWEBSITEGQLSCHEMA}
}
SortedItems{
    ${TOP10ARTICLEITEMGQLSCEHMA}
}
`;
